import { Box, Grid } from "@mui/material";
import ImageLoader from "../components/ImageLoader";
import CustomText from "../components/CustomText";
import FormDoctorsDirectory from "../components/FormDoctorsDirectory";

const DoctorsDirectory = ({ isMobile }) => {
  return (
    <Box sx={design.BackGroud}>
      <ImageLoader
        src="https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Centro_Medico_Medam_Color.png"
        alt="Logo_Centro_Medico_Medam_Color"
        width={isMobile ? 304 : 608}
        height={isMobile ? 95 : 172}
      />
      <CustomText
        variant="subtitle1"
        color="#FFFFFF"
        text="Donde la familia es nuestra prioridad"
        sx={design.Title}
      >
        {/* Del FUTURA al FUTURO */}
      </CustomText>

      <FormDoctorsDirectory />

      <Grid container sx={design.LOGO}>
        {/* <CustomText
          variant="subtitle1"
          color="#FFFFFF"
          text="by"
          sx={design.by}
        >
          by
        </CustomText>
        <ImageLoader
          src="https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_HF_Blanco.png"
          alt="Logo_Centro_Medico_Medam_Color"
          width={162}
          height={26}
        /> */}
      </Grid>
    </Box>
  );
};

export default DoctorsDirectory;

// 🎯 Estilos responsivos
const design = {
  BackGroud: {
    backgroundImage: `url(https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png)`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: {
      xs: 4,
      sm: 6,
      md: 12,
    },
    textAlign: "center",
  },
  LOGO: {
    justifyContent: "flex-end",
    width: "100%",
    paddingRight: 2,
    paddingBottom: {
      xs: 4,
      sm: 4,
      md: 4,
      lg: 4,
    },
    paddingTop: {
      xs: 4,
      sm: 6,
      md: 12,
    },
  },
  by: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 10,
      sm: 36,
      md: 48,
      lg: 10,
    },
  },
  Title: {
    fontFamily: "Plus Jakarta Sans",
    fontWeight: 600,
    color: "#FFFFFF",
    marginTop: { xs: 5, sm: 3, md: 4 },
    fontSize: {
      xs: 28,
      sm: 36,
      md: 48,
      lg: 56,
    },
    marginBottom: 4,
    lineHeight: "normal",
  },
};
